<template>
    <div class="list-packages-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formPlanes" class="formPlanes">
                <div class="row">
                    <div class="col-12 col-sm-4 offset-3">
                        <input type="text" class="al-inputs required scr-input" placeholder="Paquete" v-model="package.paquete"
                               id="paquete"/>
                    </div>
                    <div class="col-12 col-sm-2">
                        <button type="button" class="formSubmit" v-on:click="guardar()">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-md-2">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="packagesArray">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Plan)="data">
                                {{ data.item.paquete }}
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {packagesService} from "../../Services/Packages.service";

export default {
    name: "List",
    mixins: [myMixins],
    data() {
        return {
            modificar: false,
            isBusy: false,
            fields: [
                {key: 'Plan'},
                {key: 'Acciones'}
            ],
            package: {
                name: '',
            },
            packagesArray: [],
            tituloBtn: 'Agregar',
        }
    },
    methods: {
        updateReg(data = {}) {
            this.modal = 1
            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.package = data

            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async guardar() {
            //console.log('guardando');
            let resp = '';
            let respVal = this.valFormulariosV3('formPlanes');
            if (respVal) {
                //console.log('paso la validación');

                //actualizando
                if (this.modificar) {
                    // console.log('upgrade el paquete');
                    resp = await packagesService.updateOne(this.package.id, this.package);
                    this.modificar = false;
                } else {
                    //console.log('insertando el paquete');
                    resp = await packagesService.saveOne(this.package);
                }

            }

            this.setEmpty();
            this.getAlert(resp.process);
            await this.index();

        },
        async onClickDelete(id) {
            let resp = '';
            resp = await packagesService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async index() {
            let tempArray = [];
            this.isBusy = true;
            let resp = await packagesService.getMany();

            resp.forEach(function (item) {
                tempArray.push({'id': item.id, 'paquete': item.paquete});
            });

            this.packagesArray = tempArray;
            this.isBusy = false;
        },
        setEmpty() {
            this.package = {
                name: '',
            }
        }

    },
    mounted() {
        this.index();
    },
}
</script>

